import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/edit': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7v145.4c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3h-241.5v352h352v-113.5c0-2.1 0.8-4.1 2.3-5.6zM558.9 143.1l-262.6 262.6-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4 262.6-262.6c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 0.1 82.8zM460.1 174l-58.1-58.1-185.8 185.9-7.3 65.3 65.3-7.3zM524.9 94.3l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0l-30.9 30.9 58.1 58.1 30.9-30.9c4-4.2 4-10.8-0.1-14.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/edit.js
// module id = 1723
// module chunks = 0